// Copyright (c) 2016 Deere & Company

import {buildNumber} from './build-number';

export const buildPartReturnString = partRequest => {

    const quantity = buildNumber(partRequest.partQuantity);

    return `${partRequest.partNumber} - ${partRequest.partDescription} (${quantity})`;

};



// WEBPACK FOOTER //
// ./src/shared/services/build-part-return-string.js